module.exports = __webpack_public_path__ + "img/archive.ff8839b0.svg";